// extracted by mini-css-extract-plugin
module.exports = {"grid-view":"scroll-list_grid-view__LwGOD","fixed-scroll":"scroll-list_fixed-scroll__KzWEn"};